// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
function isSupported(param) {
  return Belt_Option.isSome(window.PerformanceObserver);
}
function fromEntryType(entryType) {
  return "navigation";
}
function toType(ext_type) {
  if (ext_type === "back_forward") {
    return /* BackForward */1;
  } else if (ext_type === "navigate") {
    return /* Navigate */0;
  } else {
    return /* Reload */2;
  }
}
function toEntry(ext_entry) {
  return {
    _type: toType(ext_entry.type)
  };
}
function usePerformanceObserver(enabled, options, callback, dependencies) {
  var supported = Belt_Option.isSome(window.PerformanceObserver);
  React.useEffect(function () {
    if (!(enabled && supported)) {
      return;
    }
    var observer = new PerformanceObserver(function (entries) {
      Curry._1(callback, Belt_Array.map(entries.getEntries(), toEntry));
    });
    try {
      observer.observe(options);
      var observer$1 = observer;
      return function (param) {
        Belt_Option.forEach(observer$1, function (obs) {
          obs.disconnect();
        });
      };
    } catch (e) {
      return;
    }
  }, dependencies);
}
function useLegacyNavigationTiming(enabledOpt, callback, dependencies) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var callback$1 = function (e) {
    Belt_Option.forEach(Belt_Option.map(Belt_Array.get(window.performance.getEntriesByType("navigation"), 0), function (entry) {
      return {
        _type: Belt_Option.getWithDefault(e.persisted, false) ? /* BackForward */1 : {
          _type: toType(entry.type)
        }._type
      };
    }), callback);
  };
  React.useEffect(function () {
    if (enabled) {
      window.addEventListener("pageshow", callback$1);
      return function (param) {
        window.removeEventListener("pageshow", callback$1);
      };
    }
  }, dependencies);
}
var LegacyNavigationTiming = {
  useLegacyNavigationTiming: useLegacyNavigationTiming
};
function usePerformanceObserver1(enabledOpt, bufferedOpt, entryType, callback, dependencies) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var buffered = bufferedOpt !== undefined ? bufferedOpt : false;
  var options_type = "navigation";
  var options = {
    entryTypes: undefined,
    type: options_type,
    buffered: buffered
  };
  usePerformanceObserver(enabled, options, function (entries) {
    Belt_Option.forEach(Belt_Array.get(entries, 0), callback);
  }, dependencies);
}
export { isSupported, fromEntryType, toType, toEntry, usePerformanceObserver, LegacyNavigationTiming, usePerformanceObserver1 };
/* react Not a pure module */